import { areStringArraysEqual } from './arrayUtils'

export function setStateIfChanged<T>(
    setState: React.Dispatch<React.SetStateAction<T>>,
    nextValue: T,
): void {
    setState((prev) => (Object.is(prev, nextValue) ? prev : nextValue))
}

export function setStringArrayStateIfChanged(
    setState: React.Dispatch<React.SetStateAction<string[]>>,
    nextValue: string[],
): void {
    setState((prev) =>
        areStringArraysEqual(prev, nextValue) ? prev : nextValue,
    )
}
